import { useEffect, useRef } from "react";

/**
 * Lights `.eye` eyebrows (and any `.reveal` element) as they scroll into
 * view — the small choreography the design's subpage.js provided.
 * Returns a ref to attach to the page root.
 */
export default function useReveal() {
  const ref = useRef(null);

  useEffect(() => {
    const root = ref.current;
    if (!root) return undefined;

    const targets = Array.prototype.slice.call(
      root.querySelectorAll(".eye, .reveal")
    );

    if (!("IntersectionObserver" in window)) {
      targets.forEach((el) => el.classList.add("lit", "seen"));
      return undefined;
    }

    const ob = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("lit", "seen");
            ob.unobserve(e.target);
          }
        });
      },
      { rootMargin: "0px 0px -15% 0px" }
    );
    targets.forEach((el) => ob.observe(el));

    return () => ob.disconnect();
  }, []);

  return ref;
}
